import React, { useState, useEffect } from 'react';
import api from "../../../../../../services/api";

import Select2 from "react-select2-wrapper";
import {
    Button,
    Row,
    Col,
    Input,
    FormGroup,
} from "reactstrap";

export default ({ notify, pilarId, empresaId, close, onSuccess, ...props }) => {

    const [nome, setNome] = useState(null)
    const [situacao, setSituacao] = useState('A')
    const [descricao, setDescricao] = useState(null)

    const [pilar, setPilar] = useState({})
    const [erros, setErros] = useState({})


    useEffect(() => {
        if (pilarId && pilarId != pilar.id) {
            loadPilar(pilarId)
        }
    }, [pilarId])

    useEffect(() => {
        setNome(pilar.nome)
        setSituacao(pilar.situacao ? pilar.situacao : 'A')
        setDescricao(pilar.descricao)
    }, [pilar])

    async function loadPilar(pilarId) {
        try {
            const response = await api.get(`/common/empresas/${empresaId}/pilares/${pilarId}`)
            if (response.data) {
                setPilar(response.data)
            }
            updateErros(null)
        } catch (error) {
            console.log(error)
        }
    }


    function handleSave() {
        if (pilarId) {
            update()
        } else {
            insert()
        }
    }

    async function insert() {
        try {
            console.log(situacao)
            await api.post(`/common/empresas/${empresaId}/pilares`, {
                nome,
                situacao,
                descricao
            })
            updateErros(null)
            if (onSuccess) onSuccess()
        } catch (error) {
            console.error(error)
            if (notify) notify('danger', 'Não foi possível adicionar pilar')
            if (error.response) updateErros(error.response.data)
        }
    }

    async function update() {
        try {
            await api.put(`/common/empresas/${empresaId}/pilares/${pilarId}`, {
                nome,
                situacao,
                descricao
            })
            updateErros(null)
            if (onSuccess) onSuccess()
        } catch (error) {
            console.error(error)
            if (notify) notify('danger', 'Não foi possível salvar pilar')
            if (error.response) updateErros(error.response.data)
        }
    }

    function updateErros(error) {
        if (error && error instanceof Array) {
            const errors = {}
            for (let e of error) {
                errors[e.field] = e.message
            }
            setErros(errors)
        } else {
            setErros({})
        }
    }

    return (
        <>
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                        >
                            Nome*
                        </label>
                        <Input
                            className="form-control"
                            placeholder="Nome..."
                            type="text"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />
                        <small class="text-danger">
                            {erros.nome ? erros.nome : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                        >
                            Situação*
                        </label>
                        <Select2
                            defaultValue="A"
                            onSelect={(e) => setSituacao(e.target.value)}
                            options={{
                                placeholder: "Selecione uma situação..."
                            }}
                            value={situacao}
                            data={
                                [
                                    {
                                        id: 'A',
                                        text: 'Ativo'
                                    }, {
                                        id: 'I',
                                        text: 'Inativo'
                                    }
                                ]
                            }
                        />
                        <small class="text-danger">
                            {erros.situacao ? erros.situacao : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <label
                            className="form-control-label"
                        >
                            Descrição
                        </label>
                        <Input
                            className="form-control"
                            placeholder="Descrição..."
                            type="textarea" 
                            rows={3}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                        <small class="text-danger">
                            {erros.descricao ? erros.descricao : ''}
                        </small>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="float-right ">
                        <Button
                            className="ml-auto"
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => close()}
                        >
                            Fechar
                          </Button>
                          <Button
                            color="primary"
                            onClick={handleSave}
                        >
                            Salvar
                          </Button>
                    </div>
                </Col>
            </Row>
        </>
    );
}
